import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Setting5 } from "iconsax-react";
import { memo } from "react";

import type { FilterChipProps } from "./FilterChip.types";
import * as styles from "./FilterChip.styles";

export type { FilterChipProps } from "./FilterChip.types";

export const FilterChip = memo(function FilterChip({
  label,
  active = false,
  size = "md",
  advanced = false,
  onClick,
}: FilterChipProps) {
  const theme = useTheme();

  return (
    <Chip
      label={label}
      onClick={onClick}
      clickable
      icon={
        advanced ? (
          <Setting5
            size={size === "sm" ? 14 : 18}
            variant="Linear"
            color={active ? theme.palette.common.white : theme.palette.text.secondary}
          />
        ) : undefined
      }
      sx={styles.root(active, size)}
    />
  );
});
